<template>
  <div>
    <footer
      class="relative md:container mt-auto h-40  border-t border-white/10 py-3 bg-[#0d0f15]/80"
    >
      <div
        class="mx-auto flex md:flex-row md:w-6/10 md:justify-between flex-col justify-center items-center gap-6 px-4 py-6"
      >
        <div
          class="flex w-36 items-center justify-center rounded-full text-xs font-bold"
        >
          <img src="@/assets/payments/bok.png" alt="bok-logo" class="object-cover" />
        </div>

        <div class="flex gap-6 text-xs text-gray-500">
          <a href="https://sites.google.com/view/nasnatv" class="transition hover:text-white">
            {{ t.terms }}
          </a>

          <a href="https://sites.google.com/view/nasna-tv" class="transition hover:text-white">
            {{ t.privacy }}
          </a>
        </div>

        <div
          class="text-xs text-gray-600 mb-2"
          :class="isArabic ? 'text-right' : 'text-left'"
        >
          {{ t.copyright }}
        </div>
      </div>
    </footer>
  </div>
</template>

<script>
export default {
    props: {
        t: {
        type: Object,
        required: true,
        },
        isArabic: {
        type: Boolean,
        required: true,
        },
    },
};
</script>

<style >
</style>